import md5 from 'js-md5';

/**
 * 对字符串进行 MD5 加密
 * @param str 需要加密的字符串
 * @returns 加密后的 MD5 字符串
 */
export const encryptMD5 = (str: string): string => {
  try {
    // @ts-ignore - js-md5 类型定义问题
    return md5(str);
  } catch (error) {
    console.error('MD5 encryption error:', error);
    return '';
  }
}; 